module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Medium-1b030abddceed63b66675c441b48bdd6.ttf";